module.exports = __webpack_public_path__ + "img/plus-square.8ae3c577.svg";